import React, { useEffect, useState } from 'react';
import { Table } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { reportingOp } from 'store/ducks/Reportings';
import { RootState } from 'store/configureStore';
import { set_isAdditionalDisplayed } from 'store/ducks/Reportings/reportingSlice';
import { DataCertificates } from 'store/ducks/Reportings/types';
import { certificateColumns } from 'components/Columns/CertificatesForFunctionColumns';

interface reportDataProps {
  entityName: string;
}

const CertificatesByFunction: React.FC<reportDataProps> = ({ entityName }) => {
  const { date, is_additional_displayed, function_id, ictService_id } =
    useSelector((state: RootState) => state.reportings);

  const [data, setData] = useState<DataCertificates[]>([]);
  const dispatch = useDispatch();

  const fetchData = async () => {
    dispatch(set_isAdditionalDisplayed(false));

    try {
      const [functionResponse, ictServiceResponse] = await Promise.all([
        function_id
          ? reportingOp.fetchCertificatesByFunction({
              entity_name: entityName,
              function_id,
              date,
            })
          : null,

        ictService_id
          ? reportingOp.fetchCertificatesByICTServices({
              entity_name: entityName,
              ict_service_id: ictService_id,
              date,
            })
          : null,
      ]);

      const functionCertificates =
        functionResponse?.certificates?.map((item: any) => ({
          ...item,
          certificate_source: 'Function',
        })) || [];

      const ictServiceCertificates =
        ictServiceResponse?.certificates?.map((item: any) => ({
          ...item,
          certificate_source: 'ICT Service',
        })) || [];

      const allCertificates = [
        ...functionCertificates,
        ...ictServiceCertificates,
      ];

      const formattedData: DataCertificates[] = allCertificates.map(
        (dataItem: any, index: number) => ({
          key: `${dataItem.id}-${index}`,
          certificate_registry: dataItem.certificate_registry,
          date_of_certificate_register: dataItem.date_of_certificate_register,
          date_of_issuance: dataItem.date_of_issuance,

          description: dataItem.certificate_description ?? dataItem.description,

          end_date: dataItem.end_date,
          function_id: dataItem.function_id,
          ict_service_id: dataItem.ict_service_id,
          ict_service_name: dataItem.ict_service_name,
          id: dataItem.id,
          start_date: dataItem.start_date,
          third_party_service_provider_id:
            dataItem.third_party_service_provider_id,
          validity: dataItem.validity,
          certificate_source: dataItem.certificate_source,
        }),
      );

      setData(formattedData);
    } catch (error) {
      console.log('Error fetching certificates:', error);
      setData([]);
    }
  };

  useEffect(() => {
    if (function_id || ictService_id) {
      fetchData();
    }
  }, [is_additional_displayed, function_id, ictService_id, date]);

  return (
    <Table
      columns={certificateColumns}
      dataSource={data}
      scroll={{ x: 1000, y: 430 }}
    />
  );
};

export default CertificatesByFunction;
